<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            {{$t("src.views.apps.haberler.kategori.tanimlama.mainBaslik")}}
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <el-table
                            :data="kategoriListe"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="baslik"
                                label="Başlık"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            class="buttonDel"
                                            type="text"
                                            style="font-size: 22px"
                                            icon="mdi mdi-delete">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="kategoriForm" :rules="rulesKategori" ref="kategoriForm"
                             class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.haberler.tanimlama.baslik")'
                                                  prop="baslik">:
                                        <div v-if="linkVisible" style="float: right; display: flex">
                                            <div v-if="!VisibleA">
                                                <el-link target="_blank" :underline="false"
                                                         :href="this.path">
                                                    {{this.path}}{{this.kategoriForm.link}}
                                                </el-link>
                                            </div>
                                            <el-button v-if="duzenleBtnVisible"
                                                       style="margin-left: 10px; margin-bottom: 5px"
                                                       v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                       size="mini">Düzenle
                                            </el-button>
                                            <span v-if="VisibleA">{{this.path}}</span>
                                            <el-input v-if="VisibleA" v-model="kategoriForm.link"
                                                      v-on:change="$store.commit('changeTabsClose', false); linkChange = false"
                                                      v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                      style="width: 50%" size="mini"></el-input>
                                        </div>
                                        <el-input
                                                v-model="kategoriForm.baslik"
                                                v-on:blur="linkTespit(); $store.commit('changeTabsClose', false);"
                                                placeholder='Kategori Başlığı Giriniz.'></el-input>
                                    </el-form-item>
                                </el-col>
                                <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">-->
                                    <!--<el-form-item prop="renk">-->
                                        <!--<el-color-picker v-model="kategoriForm.renk"></el-color-picker>-->
                                    <!--</el-form-item>-->
                                <!--</el-col>-->
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="kategoriTanimla('kategoriForm')"
                                           type="primary">
                                    {{$t('src.views.apps.haberler.kategori.tanimlama.kategoriEkle')}}
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('kategoriForm')" type="primary">
                                    {{$t('src.views.apps.haberler.kategori.tanimlama.kategoriGuncelle')}}
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('kategoriForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["baslik"]}}" {{$t('src.views.apps.haberler.kategori.tanimlama.sil')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="sil(selection,selectionIndex,kategoriListe), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import partnerKategoriService from '../../../../WSProvider/PartnerKategoriService'
    import PartnerService from '../../../../WSProvider/PartnerService'
    import seoService from '../../../../WSProvider/SeoService'
    import notification from '../../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userData5B = "";
    export default {
        name: "KategoriTanimlama",
        mounted() {
            this.getKategoriList();
        },
        data() {
            return {
                updateData: [],
                updateDataEN: [],
                kategoriListe: [],
                partnerKategoriKlon: [],
                path: PartnerService.path,
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                kategoriForm: {
                    baslik: '',
                    baslikEN: '',
                    baslikDE: '',
                    renk: '',
                },
                rulesKategori: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            linkTespit() {
                let self = this;
                if (this.kategoriForm.baslik && this.linkChange) {
                    seoService.linkKontrol(self.kategoriForm.baslik.replace("'", "").substring(0, 60)).then((response) => {
                        if (response.status === 200) {
                            if (self.kategoriForm.baslik) {
                                self.kategoriForm.seoBaslik = self.kategoriForm.baslik.substring(0, 60);
                                if (response.status === 200) {
                                    self.linkVisible = true;
                                    self.kategoriForm.link = response.data;
                                }
                            } else if (!self.kategoriForm.baslik) {
                                self.linkVisible = false;
                                self.kategoriForm.link = '';
                                self.kategoriForm.seoBaslik = '';
                            }
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getKategoriList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getKategoriList();
            },
            getKategoriList() {
                partnerKategoriService.pkategoriList(1).then((response) => {
                    if (response.status === 200) {
                        this.kategoriListe = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                partnerKategoriService.pKategoriDetay(scope.pkategoriId).then((response) => {
                    if (response.status === 200) {
                        this.kategoriForm.baslik = response.data.baslik;
                        this.updateKodu = response.data.pkategoriId;
                        this.partnerKategoriKlon = response.data;
                        this.btnVisible = false;
                    }
                });

            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },

            kategoriTanimla(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // this.kategoriForm.renk.slice(1)
                        partnerKategoriService.pkategoriTanimlama(this.kategoriForm.link, this.kategoriForm.baslik, this.kategoriForm.baslik, "").then((response) => {
                            if (response.status === 200) {
                                this.kategoriListe.push(response.data);
                                notification.Status('success', this, 'Kategori başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut.');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                let self = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        partnerKategoriService.pkategoriGuncelle(this.updateKodu, this.kategoriForm.link,this.kategoriForm.baslik).then((response) => {
                            if (response.status === 200) {
                                this.kategoriListe.splice(this.selectionIndex, 1);
                                this.kategoriListe.splice(this.selectionIndex, 0, {
                                    baslik: response.data.baslik,
                                    pkategoriId: response.data.pkategoriId
                                });
                                notification.Status('success', this, 'Kategori başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            sil(selection, index, list) {
                partnerKategoriService.pkategoriDurumGuncelle(selection.pkategoriId, 0).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Kategori başarıyla silindi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }
</style>